import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { API } from "./App";
import { getAuthHeader } from "./AuthRoute";

const FileUploadModal = ({ visible, onHide, projectName }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [statusMessage, setStatusMessage] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [overwrite, setOverwrite] = useState(false);
  const [isWaitingResponse, setIsWaitingResponse] = useState(false);

  const handleFileChange = (event) => {
    const filesArray = Array.from(event.target.files);
    setSelectedFiles(filesArray);
    setStatusMessage("");
  };

  const handleUpload = (overwrite) => {
    const formData = new FormData();
    selectedFiles.forEach((file) => {
      formData.append("files", file);
    });
    formData.append("project_name", projectName);

    const xhr = new XMLHttpRequest();

    xhr.open(
      "POST",
      API() +
        "/projects/" +
        projectName +
        "/upload-excel?overwrite=" +
        overwrite,
      true,
    );
    xhr.setRequestHeader("Authorization", getAuthHeader());

    setIsWaitingResponse(true);

    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        setUploadProgress(percentComplete);
      }
    });

    xhr.onload = () => {
      setIsWaitingResponse(false);
      const response = JSON.parse(xhr.responseText);
      if (xhr.status === 201) {
        setUploadProgress(100);
        setStatusMessage(response.status);
      } else {
        setStatusMessage(response.error || "Unknown error");
      }
    };

    xhr.onerror = () => {
      setIsWaitingResponse(false);
      setStatusMessage("Error: Upload failed");
    };

    xhr.send(formData);
  };

  const hide = () => {
    setSelectedFiles([]);
    setUploadProgress(0);
    setStatusMessage("");
    setIsWaitingResponse(false);
    onHide();
  };

  const footer = (
    <>
      {statusMessage ? (
        <div>
          <div
            style={{
              maxHeight: "200px",
              overflowY: "auto",
              whiteSpace: "pre-wrap",
              border: "1px solid #ccc",
              padding: "10px",
              marginBottom: "10px",
              color: "red",
              textAlign: "left",
            }}
          >
            {statusMessage}
          </div>
          {!isWaitingResponse && <Button label="Close" onClick={hide} />}
        </div>
      ) : isWaitingResponse ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <ProgressSpinner />
          <p>Processing server response...</p>
        </div>
      ) : (
        <div>
          <Button label="Cancel" onClick={hide} className="p-button-text" />
          <Button
            label="Upload"
            onClick={() => handleUpload(overwrite)}
            disabled={selectedFiles.length === 0}
          />
        </div>
      )}
    </>
  );

  return (
    <Dialog
      header="Upload Files"
      visible={visible}
      style={{ width: "50vw" }}
      footer={footer}
      onHide={hide}
    >
      {uploadProgress === 0 && (
        <input
          type="file"
          multiple
          accept="application/csvm+json"
          onChange={handleFileChange}
        />
      )}
      {selectedFiles.length > 0 && (
        <div>
          <h4>Selected Files:</h4>
          <ul>
            {selectedFiles.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>
        </div>
      )}

      {uploadProgress > 0 && uploadProgress < 100 && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <ProgressSpinner />
          <p>{Math.round(uploadProgress)}% uploading...</p>
        </div>
      )}

      <div>
        <label>
          <input
            type="checkbox"
            checked={overwrite}
            onChange={(e) => {
              const newVal = e.target.checked;
              if (newVal) {
                alert(
                  "Êtes-vous sûr de vouloir écraser les données existantes ? C'est une opération sensée être exceptionnelle :) Si vous avez un doute appelez moi",
                );
              }
              setOverwrite(newVal);
            }}
          />
          Mode d’écrasement
          <br />
          (Cochez cette case si votre fichier Excel contient des valeurs
          complètes ou les plus récentes pour : nappe, rocher, app i, disp i,
          texture i, squelette i et compacité i et commentaires pour chaque
          sondage, afin de mettre à jour la base de données du site avec ces
          informations et écraser ce qui existe sur le site.)
          <br />
          (Ne cochez pas cette case si votre fichier Excel est vide et que vous
          souhaitez le remplir à l’aide de cet outil.)
          <br />
          Par défaut cette case n'est pas cochée.
        </label>
      </div>
    </Dialog>
  );
};

export default FileUploadModal;
